<template lang="pug">
.postera
  section.u-mt-sm
    Query.grid.is-desktop-4.is-tablet-6.is-postera(
      :query="require('~/graphql/Artwork.gql').Artworks"
      :limit="6"
      :initialValue="artworks"
      :variables="{ type: 'POSTER' }"
      v-slot="{ items }"
    )
      .column.u-mb-xm(v-for="node in items" :key="node.id")
        AppCard(:img="node.thumb" ratio="4:5" :title="node.title" :url="`/tools/doodles/posters/${node.slug}`" @click="selectedItem = node")

  TheaterOverlay(
    :isActive="!!selectedItem.id"
    :title="selectedItem.title"
    :image="selectedItem.thumb"
    @close="onLeave"
  )
    //- template(#buttons)
    //-   a.patternest-overlay-download(v-if="selectedItem" :href="`/files/${selectedItem.file.id}`")
    //-     AppIcon(name="download")
</template>

<script>
import { load } from '~/directives';
import { formatPretty } from '~/utils/date';
import Query from '~/components/Query';
import TheaterOverlay from '~/components/TheaterOverlay';
import { generateSeoMeta } from '~/utils/seo';
import { Artworks, Artwork } from '~/graphql/Artwork.gql';

export default {
  key: 'posters',
  preserveScrollPosition: true,
  meta: {
    theme: 'postera dark',
    logoIcon: 'logoPosteraTypo',
    logoText: '__NONE__'
  },
  components: {
    TheaterOverlay,
    Query
  },
  filters: {
    formatPretty
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  directives: {
    load
  },
  data: () => ({
    selectedItem: {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    }
  }),
  async asyncData({ app, from, params }) {
    if (from && from.name.indexOf('ideas-graphics-posters-slug') === 0) {
      return {};
    }

    const [artworks, artwork] = await Promise.all([
      app.$api.query({
        query: Artworks,
        variables: {
          first: 12,
          type: 'POSTER'
        }
      }),
      params.slug
        ? app.$api.query({
            query: Artwork,
            variables: {
              slug: params.slug
            }
          })
        : undefined
    ]);

    let selectedItem = {
      id: null,
      thumb: '',
      title: '',
      file: {
        id: ''
      }
    };

    if (artwork) {
      selectedItem = artwork.data.artwork;
    }

    return {
      artworks: artworks.data.artworks,
      selectedItem
    };
  },
  methods: {
    onLeave() {
      this.selectedItem = {
        id: null,
        thumb: '',
        title: '',
        file: {
          id: ''
        }
      };
      this.$router.localePush('/tools/doodles/posters');
    }
  }
};
</script>

<style lang="stylus">
$clBg = #141414

div.app.is-postera
  overflow: hidden
  background: $clBg
  font-weight: $fontWeight-normal

  .header.is-scroll
    background: $clBg

  .theater-overlay
    background: alpha($clBg, 0.9)

    &-title
      color: $clWhite

    &-icons
      color: $clWhite

      >*
        margin: 0 5px

      .icon
        color: $clWhite
        fill: $clWhite

        &:hover
          fill: $clPrimary

.postera
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, .button-link
    font-weight: $fontWeight-medium

  &-share
    margin: 0 -5px

    >a
      margin: 5px

  &-intro
    padding-top: unitRes(50, 200)
    padding-bottom: 200px
    position: relative
    z-index: 2

  .grid.is-postera
    margin-right: gr(-40)
    margin-left: gr(-40)

    >.column
      padding-right: gr(40)
      padding-left: gr(40)

$clBg = #222

div.app.is-patternest
  overflow: hidden
  background: $clBg
  font-weight: $fontWeight-normal

  .header.is-scroll
    background: $clBg

.patternest
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, .button-link
    font-weight: $fontWeight-medium

  &-share
    margin: 0 -5px

    >a
      margin: 5px

  &-intro
    padding-top: unitRes(50, 200)
    position: relative
    z-index: 2

  .grid.is-patternest
    margin-right: -5px
    margin-left: -5px

    >.column
      padding-right: 5px
      padding-left: 5px

    .card
      margin-bottom: 10px

      &-body
        display: none
</style>

<i18n>
{
  "en": {
    "pageTitle":"Posters",
    "pageDesc":"Get inspired by the different art types and design compositions. Download the posters you like and start building yours.",
    "share":"Share",
    "published":"Published",
    "tools":"Tools Used",
    "download":"Download",
    "vmore":"View more"
  },
  "ar": {
    "pageTitle":"البوسترات",
    "pageDesc":"احصل على الإلهام واكسر حاجز صعوبة ابتكار الأفكار، ستجد أنواع مختلفة من الفن وتراكيب التصميم المناسبة لإلهامك في مشروعك.",
    "share":"مشاركة",
    "published":"تاريخ النشر",
    "tools":"الأدوات المستخدمة",
    "download":"تحميل",
    "vmore":"مشاهدة المزيد"
  }
}
</i18n>
